import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OutingApprovalApiService } from '../outing-approval-api.service';
import { filterAndMap } from '@progress/kendo-angular-dropdowns/common/util';
import { startWith, map } from 'rxjs';

@Component({
  selector: 'app-outing-approval-dialog',
  templateUrl: './outing-approval-dialog.component.html',
  styleUrls: ['./outing-approval-dialog.component.scss']
})
export class OutingApprovalDialogComponent implements OnInit {

  approved: any = true;
  selectedApprovedEmp: any = "";
  approvedFilter: any = new FormControl("");
  approvedOptions: any;
  activeTab: any = 'approved'
  employees: any;
  qrImage: any;
  requestData: any;
  studentCount: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<OutingApprovalDialogComponent>, private service: OutingApprovalApiService) { }
  ngOnInit(): void {
    console.log(this.data)
    this.service.getOutingRequestDetails(this.data.reqId).subscribe({
      next:(res:any)=>{
        console.log(res)
        this.requestData = res[0]
        this.studentCount = res.length
      },
      error: (err: any) => {
        console.log(err)
      }
    })
    this.service.getEmployeeList(this.data.campusId).subscribe({
      next: (res: any) => {
        this.employees = res
        this.approvedOptions = this.approvedFilter.valueChanges.pipe(
          startWith(''),
          map((value: string) => this.Filter(value, this.employees, 'payRollId'))
        )
      },
      error: (err: any) => {
        console.log(err)
      }
    })
  }

  closeDialog() {
    this.dialogRef.close()
  }

  Filter(value: string, list: any[] = [], name: string) {
    const searchValue = (value || "").trim().toLowerCase();

    return list
      .filter(item =>
        item?.[name]?.toString().trim().toLowerCase().includes(searchValue)
      );
  }


  setTab(tab: any) {
    this.activeTab = tab
  }

  getApprovedEmployee(item: any) {
    this.selectedApprovedEmp = item;
  }

  openQr() {

    const payload = {
      "outingId": this.data.outingId,
      "approvedEmpId": this.selectedApprovedEmp.employeeId,
      "confirmedEmpId": this.selectedApprovedEmp.employeeId
    }
    this.service.submitApproval(payload).subscribe({
      next: (res: any) => {
        console.log(res)
        this.service.getQrDetails(this.data.outingId).subscribe({
          next: (res: any) => {
            console.log(res)
            this.qrImage = URL.createObjectURL(res);
            this.approved = false;
          }
        })
      }
    })
  }

  shareQR() {
    fetch(this.qrImage)
      .then(res => res.blob())
      .then(blob => {
        const file = new File([blob], 'qr-code.png', { type: blob.type });

        if (navigator.share) {
          navigator
            .share({
              title: 'QR Code',
              text: 'Scan this QR code',
              files: [file]
            })
            .catch(err => console.log("Share cancelled", err));
        } else {
          alert("Sharing not supported on this device.");
        }
      });
  }

  printQR() {
    if (!this.qrImage) {
      alert("QR image not loaded.");
      return;
    }

    const printWindow = window.open("", "_blank", "width=400,height=400");
    if (!printWindow) {
      alert("Popup blocked! Allow popups to print.");
      return;
    }

    printWindow.document.write(`
    <html>
      <head>
        <title>Print QR</title>
      </head>
      <body style="margin:0; text-align:center;">
        <img src="${this.qrImage}" style="width:300px; height:300px; margin-top:20px;" />
        <script>
          setTimeout(() => { 
            window.print(); 
            window.close(); 
          }, 300);
        </script>
      </body>
    </html>
  `);

    printWindow.document.close();
  }



}
